import { RuleTrigger } from "@/generated/graphql";

// todo remove this file - it was replace by RuleType.logic graphql object

export type RuleFormData = {
  key: RuleTrigger;
  label: string;
  suffix: string;
  postfix?: string;
  defaultDays: number;
  hasOffset?: boolean;
  routeId: string;
};

export const rulesFormData: RuleFormData[] = [
  {
    key: RuleTrigger.NoContact,
    label: "Get in touch",
    suffix: "for",
    postfix: "since the last contact",
    defaultDays: 30,
    hasOffset: true,
    routeId: "nocontact",
  },
  {
    key: RuleTrigger.Birthday,
    label: "Birthday",
    suffix: "in",
    postfix: "On the birthday",
    defaultDays: 0,
    routeId: "birthday",
  },
  {
    key: RuleTrigger.GivingAnniversary,
    label: "Giving Anniversary",
    suffix: "in",
    postfix: "On the anniversary",
    defaultDays: 30,
    routeId: "givinganniversary",
  },
  {
    key: RuleTrigger.GiftAcknowledgment,
    label: "Gift Stewardship",
    suffix: "in",
    postfix: "Immediately if Gift Received",
    defaultDays: 0,
    routeId: "giftacknowledgment",
  },
  {
    key: RuleTrigger.GiftExpectation,
    label: "Upcoming Gift",
    suffix: "in",
    postfix: "before the expected gift date",
    defaultDays: 30,
    hasOffset: true,
    routeId: "giftexpectation",
  },
  {
    key: RuleTrigger.FollowUp,
    label: "Email Follow-up",
    suffix: "After",
    postfix: "if no reply to my email",
    defaultDays: 7,
    hasOffset: true,
    routeId: "followup",
  },
  {
    key: RuleTrigger.ReplyNeeded,
    label: "Reply needed",
    suffix: "visible for",
    defaultDays: 7,
    hasOffset: true,
    routeId: "replyneeded",
  },
];

export const getTriggerFromRouteId = (routeId: string): RuleTrigger => {
  return routeToRuleTriggerMap.get(routeId.toLowerCase())!;
};

const routeToRuleTriggerMap: Map<string, RuleTrigger> = new Map(
  rulesFormData.map((rule) => [rule.routeId, rule.key]),
);

export const ruleTriggerToRouteIdMap: Map<RuleTrigger, string> = new Map(
  rulesFormData.map((rule) => [rule.key, rule.routeId]),
);

export const rulesFormDataMap: Map<RuleTrigger, RuleFormData> = new Map(
  rulesFormData.map((rule) => [rule.key, rule]),
);
